import { render, staticRenderFns } from "./JoinRequestTile.vue?vue&type=template&id=172da6aa&scoped=true"
import script from "./JoinRequestTile.vue?vue&type=script&lang=js"
export * from "./JoinRequestTile.vue?vue&type=script&lang=js"
import style0 from "./JoinRequestTile.vue?vue&type=style&index=0&id=172da6aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172da6aa",
  null
  
)

export default component.exports